import { CardTypes } from '../../consts/client-detail';
import type { CardType } from '../../types';

export const getCardNumberFormat = (type: CardType) => {
  if (type === CardTypes.AmericanExpress) {
    return '#### ###### #####';
  }
  return '#### #### #### ####';
};

export const getCardCvvFormat = (type: CardType) => {
  if (type === CardTypes.AmericanExpress) {
    return '####';
  }
  return '###';
};
